import { render, staticRenderFns } from "./VInventoryItemLifecycle.vue?vue&type=template&id=546296d5"
import script from "./VInventoryItemLifecycle.vue?vue&type=script&lang=js"
export * from "./VInventoryItemLifecycle.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemLifecycle.vue?vue&type=style&index=0&id=546296d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports